import "core-js/modules/es.error.cause.js";
import { TdProgress } from '@xunlei/thunder-ui-vue3/dist/Progress';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import '@xunlei/thunder-ui-vue3/dist/Progress/styles/Progress.css';
import '@xunlei/thunder-ui-vue3/dist/__base/styles/__base.css';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/scrollbar/scrollbar.min.css';
import speedIcon from '@shared/assets/img/speed.png';
import teamIcon from '@shared/assets/img/speedup/super-started.png';
import tryingIcon from '@shared/assets/img/speedup/vip-started.png';
// 老版本图标
import oldTeamIcon from '@shared/assets/img/team.png';
import oldTryingIcon from '@shared/assets/img/trying.png';
import { inject, defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { TRY_SVIP_INJECTION_KEY } from '@remote/components/TrySVIPProvider.vue';
import { parseVersionToNumber } from '@shared/utils/index';
import { platformPath } from '@remote/platform';
export default defineComponent({
  components: {
    TdProgress,
    Swiper,
    SwiperSlide
  },
  setup() {
    const store = useStore();
    function injectStrict(key, fallback) {
      const resolved = inject(key, fallback);
      if (!resolved) {
        throw new Error(`Could not resolve ${key.description}`);
      }
      return resolved;
    }
    const injectedProps = injectStrict(TRY_SVIP_INJECTION_KEY);
    // 后续改成switch
    const onClick = () => {
      if (injectedProps.statusRef.value === 'BEFORE_TRY') {
        injectedProps.commitApplyTry();
      } else {
        store.dispatch('goVip', {
          type: 5,
          position: 'spack'
        });
      }
    };
    const isNewVipPrivilege = computed(() => {
      var _store$state$deviceIn, _store$state;
      const currentNumericVersion = parseVersionToNumber((_store$state$deviceIn = (_store$state = store.state) === null || _store$state === void 0 || (_store$state = _store$state.deviceInfoWatchData) === null || _store$state === void 0 ? void 0 : _store$state.client_version) !== null && _store$state$deviceIn !== void 0 ? _store$state$deviceIn : '0.0.0');
      const targetNumericVersion = parseVersionToNumber('3.4.0');
      return currentNumericVersion >= targetNumericVersion;
    });
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      speedIcon,
      teamIcon,
      tryingIcon,
      oldTeamIcon,
      oldTryingIcon,
      onClick,
      platformPath,
      isNewVipPrivilege,
      ...injectedProps
    };
  }
});